const randomFace = () => {
  const faces = ["🍤","😝","😁","😇","🤓","🤠"]
  const index = Math.floor(Math.random()*faces.length)

  return faces[index];
}

export default randomFace
